import { render, staticRenderFns } from "./AppendixWarranties.vue?vue&type=template&id=02212c2d&scoped=true"
import script from "./AppendixWarranties.vue?vue&type=script&lang=js"
export * from "./AppendixWarranties.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02212c2d",
  null
  
)

export default component.exports